import classNames from 'classnames'
import CheckboxField from '../Fields/CheckboxField'
import PhoneField from '../Fields/PhoneField'
import SelectField from '../Fields/SelectField'
import FieldError from './FieldError'
import FieldLabel from './FieldLabel'

const InputComponent = ({
  field, // { name, value, onChange, onBlur }
  field: { name, value },
  form,
  form: { touched, errors, setFieldValue }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  required,
  label = '',
  placeholder: placeholderProp = '',
  componentClassName: componentClassNameProp = '',
  wrapperClassName: wrapperClassNameProp = '',
  options = [],
  optionsKeys = {},
  handleChange = null,
  input = false,
  select = false,
  textarea = false,
  checkbox = false,
  phone = false,
  ...props
}) => {
  // console.log(props)
  const isSelect = select
  const isTextarea = textarea
  const isCheckbox = checkbox
  const isInput = (!isSelect && !isTextarea && !isCheckbox) || input
  const isPhoneField = phone

  const wrapperClassName = classNames('input_field_wrapper', wrapperClassNameProp, {
    select_field_wrapper: isSelect,
    textarea_field_wrapper: isTextarea,
    // checkbox_field_wrapper: isCheckbox,
  })
  const componentClassName = classNames('input_field', componentClassNameProp, {
    select_field: isSelect,
    textarea_field: isTextarea,
    checkbox_field: isCheckbox,
    input_error: errors[name] && touched[name],
  })
  const placeholder = placeholderProp || label
  const labelProps = {
    label,
    name,
    required,
  }
  const sharedProps = {
    id: name,
    placeholder,
    className: componentClassName,
  }
  const selectProps = {
    ...sharedProps,
    value,
    formikSetter: setFieldValue,
    handler: handleChange,
    options,
    optionsKeys,
  }
  const checkboxProps = {
    label,
    checked: value,
    // formikSetter: setFieldValue,
    handler: handleChange,
    className: componentClassName,
  }
  const phoneProps = {
    ...field,
    formikSetter: setFieldValue,
    className: componentClassName,
  }

  return (
    <>
      {isCheckbox ? (
        <CheckboxField {...field} {...props} {...checkboxProps} />
      ) : (
        <div className={wrapperClassName}>
          <FieldLabel {...labelProps} />

          {isPhoneField ? (
            <PhoneField {...phoneProps} />
          ) : isInput ? (
            <input {...field} {...props} {...sharedProps} />
          ) : isSelect ? (
            <SelectField {...field} {...props} {...selectProps} />
          ) : isTextarea ? (
            <textarea {...field} {...props} {...sharedProps} />
          ) : (
            ''
          )}

          <FieldError
            name={name}
            // {...field} {...form}
          />
        </div>
      )}
    </>
  )
}

export default InputComponent
